import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import validate from './GenderNonAthValidation';
import useOmrData from '../../state/omr/UseOmrData';
import NavLinks from '../../NavLinks';

import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';
import useDidMountEffect from '@usas/ui-web/utils/UseDidMountEffect';
import Constants from '@usas/ui-web/utils/Constants';
import useForm from '@usas/ui-web/utils/UseForm';

const INITIAL_FORM_STATE = {
  genderIdentityTypeId: Constants.DEFAULT_ID
}

const INITIAL_VIEW_STATE = {
  radiobuttonlist: [],
  radiobuttonlistGenderIdentity: [],
}

const useGenderIdentityNonAthO15 = () => {
  const navigate = useNavigate();
  const { personState, savePersonState, isSaved } = useOmrData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
  const [state, setState] = useState(INITIAL_VIEW_STATE);
  const {
    formState,
    errorState,
    setFormData,
    handleSubmit,
    onFormValueChanged } = useForm(INITIAL_FORM_STATE, submitFormCallback, validate);

  function submitFormCallback(formState) {

    const newPerson = {
      ...personState,
      person: {
        ...personState.person,
        genderIdentityTypeId: formState.genderIdentityTypeId
      }
    };

    savePersonState(newPerson);
  };


  useEffect(() => {
    if (personState && Object.keys(personState).length > 0) {
      if (personState.person.genderIdentityTypeId > 0) {
        if (formState.genderIdentityTypeId !== Constants.DEFAULT_ID && isSaved === false) {
          if (formState.genderIdentityTypeId !== personState.person.genderIdentityTypeId) {

            setLeftNavModalState({ ...leftNavModalState, formStateSaved: false });

          } else {

            setLeftNavModalState({ ...leftNavModalState, formStateSaved: true });
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState, personState, isSaved]);


  useEffect(() => {
    if (personState && Object.keys(personState).length > 0) {
      if (personState.person.genderIdentityTypeId === Constants.DEFAULT_ID) {
        if (formState.genderIdentityTypeId === Constants.DEFAULT_ID && isSaved === false) {

          setLeftNavModalState({ ...leftNavModalState, formStateSaved: false });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState, personState, isSaved]);

  useEffect(() => {
    if (formState.genderIdentityTypeId && personState.person) {

      const genderTypeId = personState?.person?.genderIdentityTypeId > 0
        ? personState?.person?.genderIdentityTypeId
        : Constants.DEFAULT_ID

      const newFormState = {
        ...formState,
        genderIdentityTypeId: genderTypeId
      };

      setFormData(newFormState, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personState]);

  useDidMountEffect(() => {
    if (isSaved === true) {

      setLeftNavModalState({ ...leftNavModalState, formStateSaved: true });
      //navigate(NavLinks.DISABILITIES_NON_ATHLETE_16_AND_UP);
      document.getElementById('omrHeadingId')?.scrollIntoView();
      navigate(NavLinks.NCSA_OPT_IN, { state: { fromGenderPage: true } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSaved]);

  const onBackButtonClicked = (e) => {
    e?.preventDefault();
    document.getElementById('omrHeadingId')?.scrollIntoView();
    const navLink = personState?.is16orOlder === true
      ? NavLinks.ETHNICITY_16_AND_UP
      : NavLinks.ETHNICITY_U16;

    navigate(navLink);
  };

  return {
    formState,
    errorState,
    state,
    setState,
    handleSubmit,
    onBackButtonClicked,
    onNextButtonClicked: handleSubmit,
    onFormValueChanged
  };
};

export default useGenderIdentityNonAthO15;